import { useEffect } from 'react';

/**
 * Sufixo estático capturado do primeiro `document.title` lido (o valor fixo
 * de `index.html`: "FavelaFood Admin" / "FavelaFood Comerciante" / "FavelaFood
 * Staff", dependendo do painel) — capturado uma única vez por sessão, então o
 * hook funciona nos 3 painéis sem precisar saber qual é qual.
 */
let baseTitle: string | null = null;

/**
 * ADM-36: document.title era constante por painel — 15 rotas mediram só 3
 * títulos distintos, apesar do <h1> de cada página já estar correto. Cada
 * `PageHeader` chama este hook com o título específico da rota, produzindo
 * "<Página> · FavelaFood <Painel>" (WCAG 2.1 critério 2.4.2 — Page Titled).
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    if (baseTitle === null) baseTitle = document.title;
    document.title = title ? `${title} · ${baseTitle}` : baseTitle;
  }, [title]);
}
